<template>
  <div id="device-list">
    <v-container>
      <v-card>
        <v-card-text>
          <div class="headline">デバイス一覧</div>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="deviceList"
            :items-per-page="999"
            :sort-by="'last_comm'"
            :sort-desc="true"
            :search="search"
            :custom-filter="filterDeviceList"
            hide-default-header
            hide-default-footer
          >
            <template v-slot:header>
              <thead>
                <tr>
                  <th class="text-left">ID</th>
                  <th class="text-left">
                    <span class="d-none d-sm-flex">最新データ受信</span>
                    <span class="d-flex d-sm-none">最新</span>
                  </th>
                  <th class="text-left">
                    <span class="d-none d-sm-flex">電池残量</span>
                    <span class="d-flex d-sm-none">残</span>
                  </th>
                  <th class="text-left">最新の計測記録名</th>
                  <th></th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.uid }}</td>
                  <td>
                    {{ formatDate(item.last_comm) }}
                  </td>
                  <td>{{ item.voltage | remainingBattery }}</td>
                  <td>
                    {{ item.latest_measure ? item.latest_measure.name : "" }}
                  </td>
                  <td>
                    <v-btn @click="() => openDownlinkModal(item)" class="ma-2"
                      >設定</v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>

    <downlink-modal
      :dialog="dialog"
      @close="dialog = false"
      @update="updateDownlinkData"
      @submit="updateDownlink"
      :uplinkInterval="downlink.uplinkInterval"
      :downlinkInterval="downlink.downlinkInterval"
      :channel="downlink.channel"
      :filter="downlink.filter"
      :rate="downlink.rate"
      :gain="downlink.gain"
      :mode="downlink.mode"
      :temperatureCorrection="temperatureCorrection"
      @update-correction="updateCorrectionData($event)"
      :device="selected"
    ></downlink-modal>
  </div>
</template>

<script>
import Device from "@/models/device";
import DownlinkModal from "@/components/DownlinkModal.vue";

import api from "@/api";
import dayjs from "dayjs";

export default {
  name: "DeviceList",
  components: { DownlinkModal },
  data() {
    return {
      dialog: false,
      downlink: {
        deviceId: null,
        uplinkInterval: 0,
        downlinkInterval: 0,
        channel: 15,
        filter: 0,
        rate: 0,
        gain: 0,
        mode: 0,
      },
      temperatureCorrection: {
        enabled: false,
        a: 0,
        b: 0,
        c: 0,
        d: 0,
      },
      selected: null,
      search: "",
      headers: [
        { text: "", value: "uid" },
        { text: "", value: "latest_measure" },
      ],
    };
  },
  computed: {
    deviceList() {
      return this.$store
        .$db()
        .model("devices")
        .query()
        .withAll()
        .get();
    },
  },
  filters: {
    remainingBattery: function(vol) {
      if (vol < 3) return "多";
      if (vol > 3) return "少";
      if (vol == 7) return "無";
    },
  },
  methods: {
    updateDownlink(e) {
      const params = {
        uplink_interval: this.downlink.uplinkInterval,
        downlink_interval: this.downlink.downlinkInterval,
        channel: this.downlink.channel,
        filter: this.downlink.filter,
        rate: this.downlink.rate,
        gain: this.downlink.gain,
      };
      api.devices
        .updateDownlink(this.downlink.deviceId, params)
        .then((data) => {
          Device.insert({ data });
          this.dialog = false;
        });
      api.devices
        .updateTemperatureCorrection(
          this.downlink.deviceId,
          this.temperatureCorrection
        )
        .then((data) => {
          Device.insert({ data });
        });
      api.devices
        .update(this.downlink.deviceId, e)
        .then((data) => Device.insert({ data }));
    },
    updateDownlinkData([key, value]) {
      this.downlink[key] = value;
    },
    updateCorrectionData(event) {
      this.temperatureCorrection = Object.assign(
        this.temperatureCorrection,
        event
      );
    },
    openDownlinkModal(device) {
      this.dialog = true;
      this.downlink.deviceId = device.uid;
      this.downlink.uplinkInterval = device.downlink.uplink_interval;
      this.downlink.downlinkInterval = device.downlink.downlink_interval;
      this.downlink.channel = device.downlink.channel;
      this.downlink.filter = device.downlink.filter;
      this.downlink.rate = device.downlink.rate;
      this.downlink.gain = device.downlink.gain;
      this.downlink.mode = device.downlink.mode;

      this.temperatureCorrection.enabled =
        device.temperature_correction.enabled;
      this.temperatureCorrection.a = device.temperature_correction.a;
      this.temperatureCorrection.b = device.temperature_correction.b;
      this.temperatureCorrection.c = device.temperature_correction.c;
      this.temperatureCorrection.d = device.temperature_correction.d;

      this.selected = device;
    },
    formatDate(string) {
      if (string == null) return "";
      return dayjs(string).format("YYYY/MM/DD HH:mm:ss");
    },
    filterDeviceList(value, search, item) {
      if (typeof value === "string") {
        return value.includes(search);
      }
      return (
        item.latest_measure !== null &&
        item.latest_measure.name.includes(search)
      );
    },
  },
};
</script>

<style></style>
